import { IGroupedDevices } from "common/store/DeviceStore";
import React, { FC, useContext } from "react";
import { ListItemIcon, ListItemButton, Box, Link, Typography } from "@mui/material";
import DeviceCategory from "common/constants/DeviceCategory";
import { ObstructionMetaDeviceID } from "common/constants/GlobalValues";
import { LanguageContext } from "common/contexts/LanguageContext";

interface IProps {
  blade: IGroupedDevices;
}

const BladeDevice: FC<IProps> = (props) => {
  const { blade } = props;

  const { getString } = useContext(LanguageContext);

  function handleOnDrag(e: React.DragEvent) {
    if (blade.deviceID < ObstructionMetaDeviceID) {
      e.dataTransfer.setData("deviceID", blade.deviceID.toString());
      e.dataTransfer.setData("deviceImage", blade.imageUrl ?? "");
      e.dataTransfer.setData("droppableDevice", "true");  
    } else {
      e.dataTransfer.setData("deviceID", blade.deviceCategoryID.toString());
      e.dataTransfer.setData("droppableDevice", "false");
    }
  }

  return (
    <ListItemButton disableGutters draggable onDragStart={(e) => handleOnDrag(e)}
      sx={{
        "&:hover": {
          backgroundColor: "initial",
        }, pt: "2px", pb: "2px"
      }}
    >
      {blade.imageUrl && (
        <ListItemIcon draggable onDragStart={(e) => handleOnDrag(e)} sx={{ mr: "-20px" }}>
          <img
            src={blade.imageUrl}
            alt="device icon"
            style={
              blade.deviceCategoryID === DeviceCategory.Other
                ? { height: "32px", width: "32px" }
                : { height: "40px", width: "40px" }
            }
          />
        </ListItemIcon>
      )}
      <Box display="flex" flexDirection="column" justifyContent="flex-start">
        <Typography variant="innerLevelBlade">{blade.name}</Typography>
        {blade.detailUrl && (
          <Link
            sx={{ fontSize: "10px", color: "primary.light", display: "inline-block", mt: "-8px", pl: "4px" }}
            href={blade.detailUrl || ""}
            underline="hover"
            target="_blank" // open in a new tab
            rel="noopener noreferrer" // For security reasons, add rel attribute when using target="_blank"
          >
            {getString("blade_view_details")} &gt;
          </Link>
        )}
      </Box>
    </ListItemButton>
  );
};

export default BladeDevice;
